import { forwardRef } from 'react';

import { cn } from 'components/lib/utils';
import { InputOTP, InputOTPGroup, InputOTPSlot } from 'components/ui/input-otp';

import { MfaStatusMessageType } from './StatusMessage/status-message.enum';
import StatusMessage from './StatusMessage/StatusMessage';

export interface MfaInputOTPProps {
  value?: string;
  onChange?: (value: string) => void;
  onComplete?: (value: string) => void;
  messageType?: MfaStatusMessageType;
  message?: string;
  hasError?: boolean;
  disabled?: boolean;
  maxLength?: number;
  className?: string;
  messageClassName?: string;
}

const MfaInputOTP = forwardRef<HTMLInputElement, MfaInputOTPProps>(
  (
    {
      value,
      onChange,
      onComplete,
      messageType,
      message,
      disabled = false,
      maxLength = 6,
      className,
      messageClassName
    },
    ref
  ) => {
    const handleChange = (newValue: string) => {
      onChange?.(newValue);

      if (newValue.length === maxLength) {
        onComplete?.(newValue);
      }
    };

    return (
      <div className="flex flex-col gap-2">
        <InputOTP
          ref={ref}
          maxLength={maxLength}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          containerClassName={cn('justify-center', className)}
        >
          <InputOTPGroup className="gap-0">
            {Array.from({ length: maxLength }).map((_, index) => (
              <InputOTPSlot
                key={index}
                index={index}
                className={cn(
                  'w-[40px] h-[40px]',
                  'border border-base-input',
                  'text-sm font-normal',
                  'shadow-none ring-0',
                  'bg-base-background text-base-foreground',
                  'data-[active=true]:!border-2 data-[active=true]:border-base-ring data-[active=true]:ring-0 data-[active=true]:z-10',
                  disabled && 'opacity-50 cursor-not-allowed',
                  index === 0 && 'rounded-l-[6px]',
                  index === maxLength - 1 && 'rounded-r-[6px]',
                  index !== 0 && 'border-l-0',
                )}
              />
            ))}
          </InputOTPGroup>
        </InputOTP>
        {message && (
          <StatusMessage
            message={message}
            type={messageType}
            className={messageClassName}
          />
        )}
      </div>
    );
  }
);

MfaInputOTP.displayName = 'MfaInputOTP';

export default MfaInputOTP;
